var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7999 1.25625C16.526 1.23333 16.2425 1.27869 15.9723 1.40761L9.87267 4.31886H5.53202C3.3863 4.31886 1.63392 6.08852 1.64668 8.26768C1.65743 10.1043 2.91294 11.6353 4.59456 12.0712V16.6511C4.59456 17.8027 5.54239 18.7495 6.69408 18.7495C7.84578 18.7495 8.79361 17.8027 8.79361 16.6511V12.1994H9.84582L15.9906 15.7186C17.017 16.3061 18.3526 15.5317 18.3526 14.349V2.90779C18.3526 2.00967 17.6214 1.32478 16.7999 1.25625ZM17.1026 2.90779V14.349C17.1026 14.6305 16.8532 14.77 16.6082 14.6297L10.6344 11.2107V5.33934L16.5118 2.53793C16.8282 2.40298 17.1026 2.6177 17.1026 2.90779ZM5.53202 5.56881H9.38441V10.9482H5.56864C4.0918 10.9482 2.90673 9.77656 2.89785 8.25914C2.88899 6.74312 4.06397 5.56881 5.53202 5.56881ZM5.84573 12.1994H7.54366V16.6511C7.54366 17.1315 7.17537 17.4995 6.69408 17.4995C6.2128 17.4995 5.84573 17.1315 5.84573 16.6511V12.1994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.9d707e4765bd3e5b80e4b5cb9d18dd72.svg";
export { ForwardRef as ReactComponent };